export default __webpack_public_path__ + "static/media/content-security.eff5451a.svg";